import React, {useEffect, useId, useState} from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import './Carousel.css';

/**
 * A component for a bootstrap carousel.
 * @param children the children element as the carousel content
 * @param hideControls hide the carousel controls
 * @param hideIndicators hide the carousel indicators
 * @param options bootstrap carousel options
 * @param autoPlay auto play the carousel
 * @return {*}
 * @constructor
 */
export default function Carousel({ children, hideControls, hideIndicators, options = {}, autoPlay = true, id }) {
    const reactId = useId();
    const carouselId = id || `carousel_${reactId.replace(/:/g, '_')}`;
    const [carouselRef, setCarouselRef] = useState(null);
    useEffect(() => {
        if (!carouselRef) return;

        const element = $(carouselRef);

        // Avoid double-initialization if the carousel plugin instance already exists.
        if (typeof element.carousel !== 'function') return;
        if (element.data('bs.carousel')) {
            // Already initialized – just update interval config if needed
            const instance = element.data('bs.carousel');
            if (instance && typeof instance.options === 'object') {
                instance.options = { ...instance.options, ...options };
            }
            return undefined;
        }

        // First-time initialization
        element.carousel(options);

        return () => {
            if (typeof element.carousel === 'function') {
                try {
                    element.carousel('dispose');
                } catch (e) {
                    console.debug('Carousel dispose failed:', e);
                }
            }
        };
    }, [carouselRef, options]); // children 변경에 재초기화 불필요

    return (
        <div id={carouselId}
             className="Carousel carousel slide"
             data-interval={autoPlay ? 5000 : false}
             data-ride="carousel"
             ref={setCarouselRef}>
            {!hideIndicators && children.length > 1 && (
                <ol className="carousel-indicators">
                    {children.map((node, index) => (
                        <li data-target={`#${carouselId}`}
                            data-slide-to={index}
                            className={index === 0 ? 'active' : ''}
                            key={index}></li>
                    ))}
                </ol>
            )}
            <div className="carousel-inner">
                {children.map((node, index) => {
                    return (
                        <div className={`carousel-item ${index === 0 ? 'active' : ''}`}
                             key={index}>
                            {node}
                        </div>
                    );
                })}
            </div>
            {!hideControls && children.length > 1 && (
                <a className="carousel-control-prev"
                   href={`#${carouselId}`}
                   role="button"
                   data-slide="prev">
                    <span className="carousel-control-prev-icon"
                          aria-hidden="true"></span>
                    <span className="sr-only">이전</span>
                </a>
            )}
            {!hideControls && children.length > 1 && (
                <a className="carousel-control-next"
                   href={`#${carouselId}`}
                   role="button"
                   data-slide="next">
                    <span className="carousel-control-next-icon"
                          aria-hidden="true"></span>
                    <span className="sr-only">다음</span>
                </a>
            )}
        </div>
    );
}
Carousel.propTypes = {
    children: PropTypes.node.isRequired,
    hideControls: PropTypes.bool,
    hideIndicators: PropTypes.bool,
    options: PropTypes.object,
    autoPlay: PropTypes.bool,
    id: PropTypes.string,
};
